import React from "react";

const SplitViewStyles = (props) => {
  return (
    <style>{`
        .sidebar {
          user-select: none;
          position: relative;
          width: 300px;
          min-width: 300px;
          padding: 1em;
          transition: width 300ms, min-width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
        }
  
        .sidebar-mobile {
          user-select: none;
          position: relative;
          padding: 1em;
          overflow: hidden;
          transition: height 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
        }
  
        .sidebar-closed {
          width: 0px;
          min-width: 0px;
        }
  
        .sidebar-mobile-closed {
          height: 65px;
        }
  
  
        .sidebar-content {
          position: absolute;
          z-index: 2;
          width: 300px;
          transform: translate(0px, 0);
          padding: 1em;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          transition: transform 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
        }
  
        .sidebar-content-closed {
          transform: translate(-325px, 0);
        }
  
        .collapse-icon {
          z-index: 3;
          position: absolute;
          transform: rotate(0deg);
          display: flex;
          align-items: center;
          justify-content: center;
          right: 0px;
          margin-right: 1em;
          top: 14px;
          font-size: 22px;
          color: white;
          background-color: #71AFB3;
          /* border-radius: 99999px; */
          height: 50px;
          width: 24px;
          cursor: pointer;
          transition: transform 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
          /* box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); */
         }
  
         .collapse-closed {
          transform: rotate(180deg);
         }
  
         .collapse-open {
          transform: rotate(0deg);
         }
  
         .collapse-closed-mobile {
          transform: rotate(90deg);
         }
  
         .collapse-open-mobile {
          transform: rotate(-90deg);
         }
  
         @media (max-width: 767px) {
          .__splitview_container {
            flex-direction: column;
          }
        }
      `}</style>
  );
};

export default SplitViewStyles;
